import React, { useEffect } from "react";
import Common_title from "../common-components/common-title/Common_title";

const Terms_Conditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="Privacy_policy">
      <div className="container">
        <Common_title subtitle="Terms & Conditions" />

        <div className="white_card">
          <p className="point_title">Terms & Conditions – Bazarwala</p>

          <p className="descn_text">
            Welcome to Bazarwala. By placing an order with us through our
            website, WhatsApp, or mobile apps, you agree to the following Terms
            & Conditions. These terms are designed to ensure smooth operations,
            quality service, and fair treatment for all customers.
          </p>

          <br />

          <p className="point_title">1. Service Availability</p>

          <p className="descn_text">
            Bazarwala operates in select areas and locations only up to 5 km – 8
            km, including:
          </p>

          <p className="inner_simple_text">• Kalyani</p>
          <p className="inner_simple_text">• Halisahar</p>
          <p className="inner_simple_text">• Kanchrapara</p>

          <p className="descn_text">
            Orders outside these areas may not be accepted.
          </p>

          <br />

          <p className="point_title">2. Order Cut-Off & Delivery Timing</p>

          <p className="descn_text">
            • <strong>Order Cut-Off Time:</strong> 6:00 PM – 11:59 PM
          </p>

          <p className="descn_text">
            • <strong>Delivery Window:</strong> 4:00 AM – 12:00 PM
          </p>

          <p className="simple_text">
            <strong>Instant Delivery</strong>
          </p>

          <p className="descn_text">
            • Orders placed between 4:00 AM – 11:00 AM are eligible for instant
            delivery.
          </p>

          <p className="simple_text">
            <strong>Next-Day Delivery</strong>
          </p>

          <p className="descn_text">
            • Orders placed between 6:00 PM – 12:00 PM will be delivered the
            next day between 4:00 AM – 12:00 PM.
          </p>

          <p className="descn_text">
            📌 Exact delivery time cannot be guaranteed. Delivery is
            route-based.
          </p>

          <br />

          <p className="point_title">3. Delivery Policy</p>

          <ul className="descn_text">
            <li>We offer Standard Delivery only.</li>
            <li>
              Afternoon, express, priority, or late-night deliveries are not
              available.
            </li>
            <li>
              Delivery beyond the stated window is not promised and may occur
              only under unavoidable circumstances.
            </li>
          </ul>

          <br />

          <p className="point_title">4. Minimum Order & Delivery Charges</p>

          <ul className="descn_text">
            <li>No Minimum Order Value.</li>
            <li>Delivery charges, once applied, are non-negotiable.</li>
          </ul>

          <br />

          <p className="point_title">5. Product Availability & Substitution</p>

          <ul className="descn_text">
            <li>
              Product availability depends on daily mandi supply and quality
              standards.
            </li>
            <li>If any item is unavailable or fails quality checks:</li>
          </ul>

          <p className="inner_simple_text">° The customer will be informed</p>

          <p className="inner_simple_text">
            ° The item may be replaced (only with customer approval) or removed
          </p>

          <p className="descn_text">
            • Unavailable items are not automatically delivered later unless the
            customer confirms.
          </p>

          <br />

          <p className="point_title">6. Quality Check & Issue Reporting</p>

          <ul className="descn_text">
            <li>Customers must check the order at the time of delivery.</li>
            <li>
              Any issue (missing item, damaged product, quality concern) must be
              reported within 2 hours of delivery.
            </li>
            <li>Complaints raised after this period may not be accepted.</li>
          </ul>

          <br />

          <p className="point_title">7. Order Modification & Cancellation</p>

          <p className="simple_text">
            <strong>Before Order Accepted:</strong>
          </p>

          <p className="descn_text">Orders can be modified or canceled.</p>

          <p className="simple_text">
            <strong>After Order Accepted:</strong>
          </p>

          <p className="descn_text">Orders cannot be canceled.</p>

          <p className="descn_text">
            Please review your cart carefully before placing the order.
          </p>

          <br />

          <p className="point_title">8. Customer Availability</p>

          <ul className="descn_text">
            <li>
              Customers must be available at the delivery location during the
              delivery window.
            </li>
            <li>If the customer is unavailable:</li>
          </ul>

          <p className="inner_simple_text">° We will attempt to contact you</p>

          <p className="inner_simple_text">
            ° Re-delivery depends on route feasibility and may not be guaranteed
          </p>

          <br />

          <p className="point_title">9. Pricing & Discounts</p>

          <ul className="descn_text">
            <li>Prices may change daily based on mandi rates.</li>
            <li>Random or on-request discounts are not offered.</li>
            <li>Any discount or offer is:</li>
          </ul>

          <p className="inner_simple_text">° Time-bound</p>

          <p className="inner_simple_text">° Non-transferable</p>

          <p className="inner_simple_text">
            ° Applicable only under published promotions
          </p>

          <br />

          <p className="point_title">10. Storage & Usage Responsibility</p>

          <ul className="descn_text">
            <li>
              Customers are responsible for proper storage after delivery.
            </li>
            <li>Perishable items should be refrigerated immediately.</li>
            <li>
              Fruits and vegetables should be washed thoroughly before use.
            </li>
          </ul>

          <br />

          <p className="point_title">11. Limitation of Liability</p>

          <p className="descn_text">
            Bazarwala is not responsible for issues caused by:
          </p>

          <p className="inner_simple_text">° Improper storage after delivery</p>

          <p className="inner_simple_text">° Delayed usage</p>

          <p className="inner_simple_text">
            ° Incorrect handling by the customer
          </p>

          <br />

          <p className="point_title">12. Changes to Terms</p>

          <p className="descn_text">
            Bazarwala reserves the right to update or modify these Terms &
            Conditions at any time without prior notice.
          </p>

          <p className="descn_text">
            Updated terms will be effective immediately upon posting. Continued
            use of our services implies acceptance of the revised terms.
          </p>

          <br />

          <p className="point_title">13. Contact Information</p>

          <p className="descn_text">
            📱 <strong>WhatsApp / Call:</strong> +91 9836886605
          </p>

          <p className="descn_text">
            📧 <strong>Email:</strong> apusikder60@gmail.com 
          </p>

          <p className="descn_text">
            🕐 <strong>Support Hours:</strong> 5:00 AM – 12:00 PM (All Days)
          </p>

          <br />

          <p className="descn_text">
            <strong>Bazarwala</strong>
            <br />
            Fresh • Honest • Local • Never Stored — Delivered with Care
          </p>
        </div>
      </div>
    </section>
  );
};

export default Terms_Conditions;
